import { Component, Shark } from "shark-mvc";
import { Modal } from "bootstrap";

import templateContent from "./message-details.html";
import "./style.css";

class MessageModalComponent extends Component {
	constructor () {
		super("messageModalComponent");

		this.addTemplate("", templateContent);
	}

	afterLoad () {
		this.modal = new Modal(document.querySelector("#messageModal"));
	}

	close () {
		this.set({
			open: false,
		});

		if (this.modal) {
			this.modal.hide();
		}
	}

	init () {
		this.set({
			open: false,
		});

		Shark.set({
			messageModalBody: "",
			// _saveEditingWorkSessionBtnStatusCSSClasses: "btn-success",
		});
	}

	async open (message, { cancelButtonLabel, okButtonLabel, showCancelButton } = { cancelButtonLabel: "Annulla", okButtonLabel: "Ok", showCancelButton: false }) {
		Shark.set({
			messageModalCancelButtonLabel: cancelButtonLabel,
			messageModalBody: message,
			messageModalOkButtonLabel: okButtonLabel,
			messageModalShowCancelButton: showCancelButton,
		});

		if (this.modal) {
			this.modal.show();

			return new Promise(resolve => {
				this.resolve = resolve;
				document.addEventListener("okButtonClicked", this.okButtonClicked_handler, { once: true});
				document.addEventListener("cancelButtonClicked", this.cancelButtonClicked_handler, { once: true});
			});
		}
	}

	okButtonClicked_handler () {
		messageModalComponent.resolve(true);
		messageModalComponent.resolve = null;
		document.removeEventListener("cancelButtonClicked", this.cancelButtonClicked_handler);
	}

	cancelButtonClicked_handler () {
		messageModalComponent.resolve(false);
		messageModalComponent.resolve = null;
		document.removeEventListener("okButtonClicked", this.okButtonClicked_handler);
	}

	messageModalOkBtn_clickHandler () {
		document.dispatchEvent(new Event("okButtonClicked"));
		this.close();
	}

	messageModalCancelBtn_clickHandler () {
		document.dispatchEvent(new Event("cancelButtonClicked"));
		this.close();
	}

}

const messageModalComponent = new MessageModalComponent();

Shark.registerComponent(messageModalComponent);

export default messageModalComponent;